// extracted by mini-css-extract-plugin
export default {"parent-container":"GameSection_parent-container__5uRZM","desktop-view":"GameSection_desktop-view__Pefb8","mobile-view":"GameSection_mobile-view__lKLyr"};